module.exports = __webpack_public_path__ + "img/Arrow-simple90.e3ca2251.svg";